import { CSSProperties, FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilState } from "recoil";

import { SelectOptionsDropdown } from "@ryde/controls";
import {
  IRidesCalendarEventDto,
  selectedTableRowsIdsAtomFamily,
  SelectionEnum,
} from "@ryde/shared";

import {
  applySelectionToIds,
  computeSelectionState,
  getAllRideIds,
} from "../rides-calendar.helpers";
import { RIDES_CALENDAR_ENTITY } from "./rides-calendar.constants";

interface ICornerProps {
  style: CSSProperties;
  eventMap: Map<string, IRidesCalendarEventDto[]>;
}

export const RidesCalendarCornerCell: FC<ICornerProps> = ({
  style,
  eventMap,
}) => {
  const { t } = useTranslation();
  const [selectedIds, setSelectedIds] = useRecoilState(
    selectedTableRowsIdsAtomFamily(RIDES_CALENDAR_ENTITY),
  );

  const allIds = useMemo(() => getAllRideIds(eventMap), [eventMap]);
  const selectionState = useMemo(
    () => computeSelectionState(allIds, new Set(selectedIds)),
    [allIds, selectedIds],
  );

  const handleSetChecked = (value: SelectionEnum): void => {
    setSelectedIds(prev =>
      applySelectionToIds({ ids: allIds, selectedIds: prev, value }),
    );
  };

  return (
    <div className="rc-corner-cell" style={style}>
      <span className="rc-corner-cell__select">
        <SelectOptionsDropdown
          checked={selectionState}
          setChecked={handleSetChecked}
        />
      </span>
      <span className="rc-corner-cell__label">
        {t("ride.calendar.hourColumn", { defaultValue: "Hour" })}
      </span>
    </div>
  );
};
